module.exports = __webpack_public_path__ + "img/light1.da38f91e.png";